import React from "react";

const personalInfoContent = [
  { meta: "Nome", metaInfo: "Abilio" },
  { meta: "Sobrenome", metaInfo: "Tandela" },
  { meta: "Idade", metaInfo: "30 anos" },
  { meta: "Nacionalidade", metaInfo: "Angolana" },
  { meta: "Endereço", metaInfo: "Luanda" },
  { meta: "Telefone", metaInfo: "+244923469242 / 956388829" },
  { meta: "Linguas", metaInfo: "Portugues, Ingles, Hebraico" },
];

const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PersonalInfo;
